module.exports = __webpack_public_path__ + "images/newerp_webicon.1787648603550.png";